/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { types, getEnv } from 'mobx-state-tree';
import ExploreVMUtils from './ExploreVMUtils';

// TODO: remove duplication between this and ExploreViewModel.js
const STARTING_POINTS = 'starting points';

export default types
	.model('SelectionSyncModel', {
		displayedCard: types.optional(types.string, STARTING_POINTS)
	})
	.volatile(() => ({
		// TODO: temporary here
		// need to move all the methods accessed from exploreVM into this sub model
		parentModel: null,
		vmUtils: ExploreVMUtils
	}))
	.actions((self) => {

		function getDashboardApi() {
			return getEnv(self).dashboardApi;
		}

		function setDisplayedCard(cardId) {
			self.displayedCard = cardId;
		}

		function setParentModel(model) {
			self.parentModel = model;
		}

		function setVMUtils(utils) {
			self.vmUtils = utils;
		}

		function syncSelectionListener({ info = {} }) {
			const { contentId } = info;
			if (!self.parentModel || !contentId) {
				// missing contentId? do nothing
				return;
			}
			const content = getDashboardApi().getCanvas().getContent(contentId);
			if (!content) {
				return;
			}
			const container = content.getContainer();
			if (!container) {
				return;
			}
			const isUnderCurrentDisplayedCard = container.getType() === 'exploreCard' && container.getId() === self.displayedCard;
			if (isUnderCurrentDisplayedCard) {
				self.vmUtils.onWidgetModelReady(self.parentModel, content);
			}
		}

		return {
			afterCreate() {
				getDashboardApi().getCanvasWhenReady()
					.then(canvas => canvas.on('change:content:state:status', syncSelectionListener));
			},
			setDisplayedCard,
			setParentModel,
			setVMUtils,
			beforeDestroy() {
				getDashboardApi().getCanvasWhenReady()
					.then(canvas => canvas.off('change:content:state:status', syncSelectionListener));
			}
		};
	});


// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/SelectionSyncModel.js